// @flow

import * as React from 'react';

import parseEmoji from 'app/lib/parseEmoji';
import jobCommandOneliner from 'app/lib/jobCommandOneliner';

import { type Step } from 'app/stores/ProjectPipelineStore';

type Props = {
  step: Step
};

/* eslint-disable react/require-optimization */
// TODO: Fix the architecture of these components so this one can be optimised.
// The problem is the `step` object is actually passed from the store, which is always
// the same object reference, even if mutated, so ShallowCompare functions do not work.

export default class StepName extends React.Component<Props> {
  render() {
    if (this.props.step.name) {
      const nameWithEmoji = parseEmoji(this.props.step.name);

      return (
        <span
          dangerouslySetInnerHTML={{
            __html: nameWithEmoji
          }}
        />
      );
    } else if (this.props.step.command) {
      return (
        <span className="monospace">
          {jobCommandOneliner(this.props.step.command)}
        </span>
      );
    }

    return <span>Run script or command</span>;
  }
}
